export const STANDINGS_ACTIONS = {
  standings: {
    request: 'STANDINGS/FETCH_REQUEST',
    success: 'STANDINGS/FETCH_SUCCESS',
    error: 'STANDINGS/FETCH_ERROR',
  },
  resetState: 'STANDINGS / RESET_STATE',
  changePage: 'STANDINGS / CHANGE_PAGE',
};
